<template>
    <div id="file-copy-to-modal" :style="modalStyle" class="hidden modal-new">
        <btnClose v-if="project.id"></btnClose>
        <span class="title">Copy {{ capitalizeFirstLetter(assetType) }} To</span>

        <!-- Candidate -->
        <div v-if="assetType == 'candidate'" class="modal-body-container">
            <div v-for="bin of copyToProjectTree" :key="bin.key" class="bin-container">
                <v-expansion-panels :value="expanded" accordion>
                    <v-expansion-panel expand>
                        <v-expansion-panel-header>
                            <span class="bin-name">{{ bin.name }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="assets-container">
                                <div v-for="asset of bin.children" :key="asset.key" class="asset-container">
                                    <v-lazy>
                                        <Thumbnail :item="asset" @click.native="selectedItem = asset" :class="{ '--selected': selectedItem && selectedItem.key == asset.key }" />
                                    </v-lazy>
                                    <span class="asset-name">{{ nicename(asset.name) }}</span>
                                </div>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>

        <!-- Image, Match -->
        <v-treeview
            v-else
            id="project-tree-copy-to"
            :active="active"
            :items="copyToProjectTree"
            :open="openBins"
            activatable
            dense
            open-on-click
            return-object
            @update:active="onSelection"
        >
            <template v-slot:prepend="{ item, open }">
                <!--				<div v-if="item.type == 'image'" class="thumbnail-container">-->
                <!--					<img-->
                <!--						:src="thumbnail(item.id)"-->
                <!--						class="file-thumbnail"-->
                <!--						alt="thumbnail"-->
                <!--						@click="selectedItem = item"-->
                <!--					/>-->
                <!--				</div>-->

                <i class="material-icons">{{ open ? "folder_open" : "folder" }}</i>
            </template>

            <template v-slot:label="{ item }">
                <!--				<div class="file" :file_id="item.id" v-if="['image', 'match', 'candidate'].includes(item.type)" @click="selectedItem = item">-->
                <!--					<span class="file-name">-->
                <!--						{{ nicename(item.name, true) }}-->
                <!--					</span>-->
                <!--				</div>-->

                <span>{{ item.name }}</span>
            </template>
        </v-treeview>

        <div :class="{ '--candidate': assetType == 'candidate' }" class="buttons-continer">
            <button
                :class="{ '--disabled': inProcess }"
                :disabled="!active.length && !selectedItem"
                class="modal-btn --primary"
                type="button"
                @click="onConfirm"
            >
                <v-progress-circular v-if="inProcess" color="#fff" indeterminate size="18" width="3"
                ></v-progress-circular>
                <span v-else>Copy</span>
            </button>
            <button class="modal-btn --cancel" type="button" @click="onCancel">Cancel</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import btnClose from "@/components/app/buttons/modal/Close";
import FilenameMixin from "@/mixins/Filename";
import Thumbnail from "@/components/app/projects/Thumbnail";

export default {
    mixins: [FilenameMixin],

    components: {
        btnClose,
        Thumbnail
    },

    data() {
        return {
            active: [],
            openBins: [],
            selectedItem: null,
            inProcess: false,
            expanded: 0,
        };
    },
    computed: {
        ...mapState("Projects", ["project", "copyToProjectTree"]),
        ...mapGetters("Projects", ["thumbnail", "candidates"]),

        assetType() {
            return this.$store.state.Projects.action.type;
        },

        modalStyle() {
            if (this.assetType == "candidate")
                return {
                    width: "50%",
                    height: "80%",
                };
            else return null;
        },
    },

    methods: {
        ...mapActions("Helpers", ["revokeObjectURL"]),

        nicename(name, stripTimestampOnly = false) {
            if (stripTimestampOnly) return this.stripTimestamp(name);
            else return this.stripTimestampAndExtension(name);
        },

        onSelection(items) {
            this.active = items;
        },

        async onConfirm() {
            if (this.inProcess) return;
            this.inProcess = true;
            vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

            if (this.$store.state.Projects.action.type == "candidate") await this.copyCandidate();
            else await this.copyImageMatch();

            vm.$store.dispatch("Loader/showProgressBar", false);

            this.inProcess = false;
            window.UI.hideModal();
            this.active = [];
            this.selectedItem = null;
            this.openBins = [];
        },

        async copyCandidate() {
            const candidatesFromTargetImage = this.candidates(this.selectedItem.id);
            const candidateNamesFromTargetImage = candidatesFromTargetImage.map(e => e.name);
            const cloningFileNames = [];
            const cloningFiles = [];

            this.$store.state.Projects.action.data.forEach(file => {
                if (candidateNamesFromTargetImage.includes(file.name)) return; // skip files that are already in target bin
                if (cloningFileNames.includes(file.name)) return; // skip cloning of files with same name

                cloningFileNames.push(file.name);
                cloningFiles.push(file);
            });

            if (cloningFiles.length == 0) return;

            await this.$store.dispatch("Projects/copyFile", {
                file_id: cloningFiles[0].id,
                file_ids: cloningFiles.map(e => e.id),
                type: "file",
                destination: this.selectedItem.id,
            });

            await this.$store.dispatch("Projects/refreshProjectTree");

            if (this.$store.state.Projects.action.data.length == 1) window.UI.message.activate("Candidate copied successfully");
            else window.UI.message.activate("Candidates copied successfully");

            // this.$store.dispatch("Projects/fetchThumbnails");

            if (this.selectedItem.id == this.$store.state.Projects.image) {
                window.lutify.switchCandidates(this.$store.state.Projects.image);
            }
        },

        async copyImageMatch() {
            const folderSlug = this.assetType == "image" ? "media" : "matches";
            const targetFiles = this.active[0].files.find(folder => folder.slug == folderSlug).files;
            const targetFileNames = targetFiles.map(e => e.name);
            const cloningFileNames = [];
            const cloningFiles = [];

            this.$store.state.Projects.action.data.forEach(file => {
                if (targetFileNames.includes(file.name)) return; // skip files that are already in target bin
                if (cloningFileNames.includes(file.name)) return; // skip cloning of files with same name

                cloningFileNames.push(file.name);
                cloningFiles.push(file);
            });

            if (cloningFiles.length == 0) return;

            await this.$store.dispatch("Projects/copyFile", {
                file_id: cloningFiles[0].id,
                file_ids: cloningFiles.map(e => e.id),
                type: "folder",
                destination: this.active[0].id,
            });

            await this.$store.dispatch("Projects/refreshProjectTree");

            if (this.assetType == "image") {
                if (this.$store.state.Projects.action.data.length == 1) window.UI.message.activate("Image copied successfully");
                else window.UI.message.activate("Images copied successfully");
            } else {
                if (this.$store.state.Projects.action.data.length == 1) window.UI.message.activate("Match copied successfully");
                else window.UI.message.activate("Matches copied successfully");
            }

            // NOTE: copy thumbnails from local storage
            // this.$store.dispatch("Projects/fetchThumbnails");

            if (this.$store.state.Projects.action.type == "match") {
                window.lutify.switchMatches();
            }
        },

        onCancel() {
            window.UI.hideModal();
            this.active = [];
            this.openBins = [];
            this.selectedItem = null;
        },
    },
};
</script>

<style lang="scss">
#file-copy-to-modal {
    .buttons-continer.--candidate {
        margin-top: auto;
    }

    .modal-body-container {
        margin-bottom: 50px;
        overflow-y: scroll;
        scrollbar-color: #989898 transparent;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #989898;
            border-radius: 50px;
        }
    }

    .v-expansion-panel {
        background: transparent;
        color: inherit;

        &:before {
            display: none;
        }

        .v-expansion-panel-header {
            padding: 0;
            min-height: auto;
            flex-direction: row-reverse;
            // margin-bottom: 10px;

            &:before {
                display: none;
            }

            span {
                font-size: 12px;
                font-weight: bold;
            }

            .v-expansion-panel-header__icon i {
                font-size: 18px;
                color: var(--font-default-color);
            }
        }

        .v-expansion-panel-content__wrap {
            margin-bottom: 60px;
            padding: 0;
        }
    }

    .bin-container {
        &:not(:first-of-type) {
            margin-top: 15px;
        }
    }

    .assets-container {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        padding-right: 10px;
        // margin-left: -3px;
        // margin-right: -3px;

        .asset-container {
            min-width: 0;
            cursor: pointer;

            .file-thumbnail {
                border-radius: var(--thumbnail-lg-border-radius);
                border: 3px solid transparent;

                &.--selected {
                    border: 3px solid var(--primary);
                }
            }

            .asset-name {
                line-height: 22px;
                font-size: 12px;
                height: 22px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: block;
            }
        }
    }
}

#project-tree-copy-to {
    margin-bottom: 50px;
    height: 300px;
    // scrollbar-width: none;
    background: transparent;
    color: #989898;
    font-size: 1rem !important;

    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: #989898 transparent;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #989898;
        border-radius: 50px;
    }

    .v-icon {
        color: #989898;
    }

    .v-treeview-node__label {
        line-height: 1;
    }

    .v-treeview-node__root:before,
    .v-treeview-node__toggle {
        transition: none;
    }

    .v-treeview-node__toggle:after {
        display: none;
    }

    .thumbnail-container {
        width: 50px;
        height: 35px;
        margin-right: 5px;

        .file-thumbnail {
            width: 100%;
            height: 100%;
            object-fit: contain;
            padding: 3px 0;
            // border-radius: var(--thumbnail-sm-border-radius);
        }
    }
}
</style>
